import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Blog } from "../../../components/Blog";
import { Flex } from "../../../components/Flex";
import { FontSize } from "../../../components/Text";
import { blogsSliceSelectors } from "../../../redux/blogs/blogs.selector";
import { useAppSelector } from "../../../redux/store";
import { Rounded } from "../../../theme/Rounded";
import { Spacing } from "../../../theme/Spacing";

const MoreArticlesLink = styled.a`
  background-color: ${({ theme }) => theme.main};
  color: ${({ theme }) => theme.white};
  text-decoration: none;
  display: block;
  padding: ${Spacing.s};
  font-size: ${FontSize.m};
  width: 100%;
  text-align: center;
  border-radius: ${Rounded.md};
  transition: all 0.3s;
  margin-bottom: ${Spacing.l};
  width: fit-content;
  padding-inline: ${Spacing.xl};

  &:hover {
    background-color: ${({ theme }) => theme.lightMain};
    color: ${({ theme }) => theme.white};
  }
`;

const Container = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${Spacing.m};
  padding-bottom: ${Spacing.m};
  min-height: 100%;
`;

export const NotificationsBlogTab: React.FC = () => {
  const { t } = useTranslation();

  const blogs = useAppSelector(blogsSliceSelectors.selectBlogs);

  return (
    <Container>
      {blogs.map((p) => (
        <Blog post={p} key={p.id} />
      ))}

      <MoreArticlesLink href="https://www.atiragrup.com" target="_blank">
        {t("blog.more_articles")}
      </MoreArticlesLink>
    </Container>
  );
};
